@if (commonService.showNavbar) {
	<nr-nav-bar></nr-nav-bar>
}

<div class="app-body container-fluid">
	<router-outlet></router-outlet>
</div>

@if (commonService.showFooter) {
	<nr-footer></nr-footer>
}
